import { useRecoilState, useRecoilValue } from "recoil";
import { get, post } from "../..";
import useApiActions from "../../../recoil/api";
import { authState } from "../../../recoil/auth";
import {
  evaluateArrayIndexSelector,
  evaluateComboState,
  evaluateIndexState,
  evaluationItemsState,
  evaluationListState,
  evaluationQuestionsListState,
} from "../../../recoil/rater/evaluation";

const useEvaluationActions = () => {
  const { getWithToken, postWithToken, putWithToken } = useApiActions();
  const authSettings = { authorization: useRecoilValue(authState)?.token };
  //user_sn,
  const auth = useRecoilValue(authState);
  //문항 번호
  const evaluateIndex = useRecoilValue(evaluateIndexState);
  //콤보 번호
  const evaluateCombo = useRecoilValue(evaluateComboState);
  //내 평가 정보
  const [evaluationList, setEvaluationList] =
    useRecoilState(evaluationListState);
  //평가 문항 정보
  const evaluationQuestionsList = useRecoilValue(evaluationQuestionsListState);
  //평가 items
  const evaluationItems = useRecoilValue(evaluationItemsState);
  //평가 문항 index
  const evaluateArrayIndex = useRecoilValue(evaluateArrayIndexSelector);

  return {
    getEvaluationItems,
    getRaterRoomList,
    getEvaluationQuestionsList,
    getRaterCommentList,
    evaluateUserAnswer,
    postRaterComment,
    postRaterComment2,
    getEvaluationDetail,
    getEvaluationComboNumber,
    setRevaluation,
  };

  async function getEvaluationItems(params) {
    const res = await getWithToken("rater/nextrate", params);

    return res;
  }

  async function getRaterRoomList() {
    const res = await getWithToken("rater/testroomList");
    return res;
  }

  async function getEvaluationQuestionsList(params) {
    const res = await get("rater/EQuestions", {
      ...params,
      user_sn: auth.user.sn,
    });
    return res;
  }

  async function getRaterCommentList(req) {
    let params = { ...req };
    if (evaluationItems.question) {
      params = {
        tester_sn: req?.tester_sn || evaluationItems.tester_sn,
        question_sn:
          req?.question_sn ||
          evaluationItems?.question[evaluateArrayIndex].question_sn,
      };
    }

    const res = await getWithToken("rater/comment", params);
    return res;
  }

  async function postRaterComment(params) {
    const data = {
      ...params,
      tester_sn: evaluationItems.tester_sn,
      question_sn: evaluationItems?.question[evaluateArrayIndex].question_sn,
    };

    const res = await postWithToken("rater/comment", data);
    return res;
  }

  async function postRaterComment2(params) {
    const res = await postWithToken("rater/comment", params);
    return res;
  }

  //평가 완료 버튼 눌렀을 때 로직
  async function evaluateUserAnswer() {
    //평가 배열 번호

    let params = {
      //평가 정보
      tester_sn: evaluationItems.tester_sn,
      combo_sn: evaluationItems.combo_sn,
      //내 평가 점수
      comboList: evaluationList,
    };

    const res = await postWithToken("rater/rating", params);
    if (res.data === 200) {
      setEvaluationList([{}, {}, {}]);
    }
    return res;
  }

  async function getEvaluationDetail(params) {
    return getWithToken("rater/testroom/reassessmentList", params);
  }

  async function getEvaluationComboNumber(params) {
    return getWithToken("rater/testroom/reassessment", params);
  }

  async function setRevaluation(params) {
    return putWithToken("rater/reassessment", params);
  }
};

export default useEvaluationActions;
